import { LayoutWrapper } from 'components/base/Menu/SearchableMenu';
import AnimatedCaret from 'components/base/AnimatedCaret';
import styled, { css } from 'styled-components/macro';
import { ThemeProps } from 'types/styled';
import Box from 'components/elements/Box';
import colors from 'styles/themes/colors';
import { ListsScrollableWrapper } from 'components/base/Menu/SearchableMenu';
import { MenuRoot, MenuButton } from '../../Menu';
import Span from 'components/elements/span';

export const DropdownLabel = styled('span')<{ isSmallScreen?: boolean }>`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${colors.MediumGrey};
  padding-left: 8px;
  padding-bottom: 0.25rem;

  ${({ isSmallScreen }): any =>
    isSmallScreen &&
    css`
      padding-left: 5px;
      font-weight: 600;
    `}
`;

export const ListLabelSpan = styled('span')<{ isUppercase?: boolean }>`
  display: block;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 1px;
  margin-left: 18px;
  padding: 12px 0;
  color: #8da5bf;

  ${({ isUppercase }): any =>
    isUppercase &&
    css`
      text-transform: uppercase;
    `}
`;

export const ButtonBox = styled(Box)<ThemeProps<'div'>>`
  background: ${({ selected }): string =>
    selected ? colors.AccentGreen : colors.LightGrey};

  @media screen and (max-width: 47em) {
    background: none;
  }

  min-width: 31px;
  border-radius: 40px;
  font-size: 13px;
  padding: ${({ selected }): string =>
    selected ? '5px 9px 5px 13px' : '5px 13px'};

  @media screen and (max-width: 47em) {
    padding: 0px 5px;
    font-size: 16px;
    border-radius: none;
  }
`;

export const CaretSpan = styled(Span)`
  margin-left: auto;
  align-self: auto;

  @media screen and (max-width: 47em) {
    margin-top: -15px;
  }
`;

export const Caret = styled(AnimatedCaret)<{
  selected: boolean;
  disabled: boolean;
}>`
  @media screen and (min-width: 47em) {
    path {
      fill: ${({ selected, disabled }): string =>
        selected
          ? colors.White
          : disabled
          ? colors.DisabledGrey
          : colors.NightBlue};
    }
  }
`;

export const DropdownWrapperStyle = styled('div')<{ isSmallScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-right: 33px;

  ${LayoutWrapper}, figure {
    margin-top: 6px;
  }

  @media screen and (max-width: 1500px) {
    margin-right: 20px;
  }

  @media screen and (max-width: 1250px) {
    margin-right: 15px;
  }

  @media screen and (max-width: 1210px) {
    margin-right: 10px;
  }

  ${MenuButton} {
    width: auto;
    min-width: 75px;
  }

  @media screen and (max-width: 47em) {
    ${LayoutWrapper}, figure {
      margin-top: 10px;
    }

    ${MenuButton} {
      width: 100%;
    }
    margin: 0 20px;
    padding: 11px 0;

    border-bottom: 1px solid ${colors.LightGrey};
  }
`;

export const WideSearchableMenu = styled(DropdownWrapperStyle)<any>`
  ${MenuRoot} {
    width: 100%;
  }
  ${MenuButton} {
    width: auto;
    min-width: 75px;
  }
  ${LayoutWrapper} {
    ${({ isEnabled }: { isEnabled: boolean }): string =>
      isEnabled ? 'min-width: 20em;' : ''}
    ${({ maxWidth }): string => (maxWidth ? `max-width: ${maxWidth};` : '')}
  }
  @media screen and (max-width: 47em) {
    ${LayoutWrapper} {
      min-width: 100%;
    }

    ${MenuButton} {
      width: 100%;
    }
  }

  ${ListsScrollableWrapper} {
    max-height: 28em;
  }

  @media screen and (max-width: 47em) {
    margin: 0 20px;
    border-bottom: 1px solid ${colors.LightGrey};
  }
`;
